import apiClient from './apiClient';

export const getContactDetails = async () => {
  const { data } = await apiClient.get('/api/contact-details');
  return data;
};

export const saveContactDetails = async (contact) => {
  if (contact && contact._id) {
    const { _id, ...body } = contact;
    const { data } = await apiClient.put(`/api/contact-details/${_id}`, body);
    return data;
  }
  const { data } = await apiClient.post('/api/contact-details', contact);
  return data;
};

export const submitContactMessage = async (payload) => {
  const { data } = await apiClient.post('/api/contact-messages', payload);
  return data;
};


